<template>
    <div id="oClass">
        <!-- 浏览器认证 -->
        <div
            class="asc Brower"
            v-if="browserVersionShow"
        >
            <div
                class="exitBrower"
                :style="{
                    background: `url(${IMG_BASE_URL}exitBrowser.png) no-repeat`,
                    backgroundSize: 'cover',
                }"
            >
                <div class="tolink">
                    <a
                        href="https://www.google.com/chrome/"
                        target="_blank"
                    ></a>
                    <a href="https://www.mozilla.org/" target="_blank"></a>
                    <a href="https://www.apple.com/safari/" target="_blank"></a>
                </div>
                <div class="cancel" @click="exitBrower()"></div>
            </div>
        </div>
        
        <!-- 操作说明轮播图 -->
        <transition
            name="fade"
            enter-active-class="animated bounceIn"
            :duration="200"
        >
            <div class="imgBox" v-if="imgShow" @click="delImg()">
                <img
                    class="imgBoxs"
                    v-for="(item, i) in imgList"
                    :src="item"
                    :key="i"
                />
                <div
                    class="delVideo delImg"
                    @click="delImg()"
                    :style = "{ background: `url(${IMG_BASE_URL}delVideo.png) no-repeat`}"
                ></div>
                <div
                    id="leftArrow"
                    class="arrow"
                    :style = "{ background: `url(${IMG_BASE_URL}opleftArrow.png) no-repeat`}"
                    @click="leftArrow"
                ></div>
                <div
                    id="rightArrow"
                    class="arrow"
                    :style = "{ background: `url(${IMG_BASE_URL}oprightArrow.png) no-repeat`}"
                    @click="rightArrow"
                ></div>
            </div>
        </transition>

        <!-- 首次进入视频展示 -->
        <div class="asc videoShow" v-show="firstVideoVisible">
            <div
                class="delVideo"
                @click="delVideo"
                :style = "{ background: `url(${IMG_BASE_URL}delVideo.png) no-repeat`}"
            ></div>
            <div class="pauseBg" v-show="playVideoShow">
                <span
                :style = "{ background: `url(${IMG_BASE_URL}pause.png) no-repeat`}"
                    class="pause"
                    @click="playVideo()"
                ></span>
            </div>
            <video
                id="video"
                @ended="ended"
                controls
                controlslist="nodownload"
                width="100%"
                height="100%"
                style="objectfit: fill"
                :src="getFirstVideoUrl()"
            ></video>
        </div>
        <!-- 接口请求异常处理弹窗  interfaceErrorShow-->
        <div class="asc interfaceErrorMask" v-show="interfaceErrorShow">
            <div class="codeIndexDialogMask">
                <div
                    class="interfaceError"
                    :style="{
                        background:
                            'url(' +
                            createURL +
                            '/static/images/welcome/' +
                            lang +
                            '/errMsg.png' +
                            ') no-repeat',
                    }"
                >
                    <!-- 在试一次 按钮 -->
                    <div
                        ref="interfaceErrorBtn"
                        class="adoptLeftBtn failAcceptClick interfaceErrorBtn"
                        :style = "{ background: `url(${IMG_BASE_URL}sessionOut01.png) no-repeat`}"
                        @click="interfaceAgian()"
                    ></div>
                </div>
            </div>
        </div>
        <!-- 通关的恭喜图 '+createURL+'-->
        <transition
            name="fade"
            @enter="ideResize"
            enter-active-class="animated bounceIn"
            :duration="200"
        >
            <div class="asc" v-show="passAllLevelShow">
                <div
                    class="passAll"
                    :style="{
                        background:
                            'url(' +
                            createURL +
                            '/static/images/welcome/' +
                            lang +
                            '/' +
                            pathAllImage +
                            '/passAllLevel.png' +
                            ') no-repeat',
                    }"
                >
                    <div class="qr-code-box qr-code-box1" v-if="qrCodeShow2">
                        <vue-qr
                            :logoSrc="config.logo"
                            :text="getQRcode"
                            class="qr-code-pic qr-code-pic1"
                            :correctLevel="3"
                            :margin="0"
                            :dotScale="1"
                        >
                        </vue-qr>
                    </div>
                    <div class="delpassAll" @click="delPassAll()"></div>
                </div>
            </div>
        </transition>
        <!--蒙版-->
        <div class="v-modal" style="z-index: 1999" v-show="maskBox"></div>
        <!--载入文字-->
        <div
            class="loadingTextBg"
            style="z-index: 4000"
            v-show="isLoading || !imagesLoaded"
        >
            <p class="loadingText" :dir="dirLang">{{ loadingText }}</p>
        </div>
        <!-- 弹出框父节点 -->
        <div class="dialogParent">
            <!-- 胜利弹窗 -->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200"
            >
                <div
                    v-show="adoptDialog"
                    class="adoptDialog successDialog newPass"
                    ref="successDialog"
                    :style="{ background: `url(${createURL}/static/images/popWin_055.png) no-repeat`}"
                >
                    <!-- 标题 -->
                    <div class="winDialogTitle_txt_c" :dir="dirLang">
                        {{ $t("congx") }}
                    </div>
                   
                    <!-- 胜利弹窗标题 范围 -->
                    <div class="winDialogTitle">
                        <!-- 胜利弹窗标题 star -->
                        <div
                            class="winDialogTitle_txt"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_061.png) no-repeat`}"
                            v-show="star === 1"
                        ></div>
                        <div
                            class="winDialogTitle_txt winDialogTitle_txt02"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_062.png) no-repeat`}"
                            v-show="star === 2"
                        ></div>
                        <div
                            class="winDialogTitle_txt winDialogTitle_txt03"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_063.png) no-repeat`}"
                            v-show="star === 3"
                        ></div>
                    </div>
                    <div v-if="zhShow">
                        <div class="videoCrossContainer" v-if="showEndElapse">
                            <img src="../../static/images/win/v1001.png" style="cursor: pointer;" @click="playVideoHandler" />
                            <div>点击按钮，观看解析视频</div>
                        </div>
                        <div class="videoCrossContainer" v-if="showUnVip">
                            <img src="../../static/images/win/v1003.png" />
                            <div>成为正式宇航员，观看解析视频</div>
                        </div>
                        <div class="videoCrossContainer"  v-if="showElapse">
                            <div class="videoCrossContainerTxt">{{elapseTimeTxt}}</div>
                            <div>再思考一下，稍后观看解析视频</div>
                        </div>
                        <div class="videoCrossContainer" v-if="showUnConfig" >
                            <img style="margin-top:-30px;margin-left:-2px;" src="../../static/images/win/v1005.png" />
                        </div>
                    </div>
                    <!-- 胜利弹窗内容 范围 -->
                    <div class="winDialogContent">
                        <div
                            class="winDialogContent_txt"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_058.png) no-repeat`}"
                        >
                            <i
                                class="winDialogContent_txt_i i_2"
                                v-show="curSteps <= configSteps"
                                :style = "{ background: `url(${IMG_BASE_URL}success_00.png) no-repeat`}"
                            ></i>
                            <i
                                class="winDialogContent_txt_i i_2"
                                v-show="curSteps > configSteps"
                                :style = "{ background: `url(${IMG_BASE_URL}error_00.png) no-repeat`}"
                            ></i>
                            <i
                                class="winDialogContent_txt_i i_3"
                                v-show="curLine <= configLine"
                                :style = "{ background: `url(${IMG_BASE_URL}success_00.png) no-repeat`}"
                            ></i>
                            <i
                                class="winDialogContent_txt_i i_3"
                                v-show="curLine > configLine"
                                :style = "{ background: `url(${IMG_BASE_URL}error_00.png) no-repeat`}"
                            ></i>
                            <div
                                class="step_line sl_01"
                                v-show="curSteps <= configSteps"
                                :style = "{ background: `url(${IMG_BASE_URL}step_01.png) no-repeat`}"
                            ></div>
                            <div
                                class="step_line sl_02"
                                v-show="curSteps > configSteps"
                                :style = "{ background: `url(${IMG_BASE_URL}step_02.png) no-repeat`}"
                            ></div>
                            <div
                                class="step_line sl_03"
                                v-show="curLine <= configLine"
                                :style = "{ background: `url(${IMG_BASE_URL}line_01.png) no-repeat`}"
                            ></div>
                            <div
                                class="step_line sl_04"
                                v-show="curLine > configLine"
                                :style = "{ background: `url(${IMG_BASE_URL}line_02.png) no-repeat`}"
                            ></div>
                        </div>
                    </div>
                    <div class="winDialogTitle_txt_step">
                        <span :class="{ curColor: curSteps > configSteps }">{{
                            curSteps
                        }}</span
                        ><span
                            style="color: #fff"
                            :class="{ curColor1: curSteps <= configSteps }"
                            >/</span
                        ><span>{{ configSteps }}</span>
                    </div>
                    <div class="winDialogTitle_txt_line">
                        <span :class="{ curColor: curLine > configLine }">{{
                            curLine
                        }}</span
                        ><span
                            style="color: #fff"
                            :class="{ curColor1: curLine <= configLine }"
                            >/</span
                        ><span>{{ configLine }}</span>
                    </div>
                    <div class="qr-code-box" v-if="qrCodeShow">
                    </div>
                    <button
                        v-if="!highCheckShow && adoptDialog"
                        class="adoptLeftBtn successLeft abx bg_popWin_057"
                        @click="adoptRightBtn"
                    ></button>
                    <button
                        v-if="isLastLevel"
                        class="adoptLeftBtn successLeft abx"
                        :style = "{ background: `url(${IMG_BASE_URL}exit.png) no-repeat`}"
                        @click="exitHandler"
                    ></button>
                    <div
                        class="adoptRightBtn successRight abx"
                        :class="{ highCheck: isLastLevel?false:highCheckShow }"
                        :style = "{ background: `url(${IMG_BASE_URL}popWin_056.png) no-repeat`}"
                        @click="adoptLeftBtn"
                    ></div>
                </div>
            </transition>
            <!-- 胜利弹窗中文版本 通关-->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200"
            >
                <div
                    class = "adoptDialog adoptDialogChina"
                    :style = "{background: `url(${IMG_BASE_URL}newChina.png) no-repeat`}"
                    v-show = "adoptChinaDialog"
                >
                    <!-- 星星总数 -->
                    <div class="winDialogContentChina_star" :dir="dirLang">
                        {{ $t("all_star") }}
                    </div>
                    <!-- 胜利弹窗标题 范围 -->
                    <div
                        class="winDialogTitle winDialogTitleChina"
                        v-text="allStar"
                    >
                    </div>
                    <!-- 胜利弹窗内容 范围 -->
                    <div class="winDialogContent winDialogContentChina">
                        <!-- 胜利弹窗内容 文字 -->
                        {{ $t("ok_pass") }}
                        <div
                            class="winDialogContent_txt winDialogContent_txtChina"
                            :dir="dirLang"
                        ></div>
                    </div>
                    <div
                        class="adoptLeftBtn adoptLeftBtnChina allsuccess bg_errorChina_03"
                        @click="failCancelClickChina"
                    ></div>
                </div>
            </transition>
            <!-- 失败弹窗，重置弹窗， 推出游戏弹窗 -->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200"
            >
                <div class="codeIndexDialogMask" v-if="failDialog">
                    <div
                        class="adoptDialog failDialog adoptDialog_en"
                        :style = "{ background: `url(${IMG_BASE_URL}popWin_03.png) no-repeat`}"
                    >
                        <!-- 失败弹窗标题 范围 -->
                        <div class="failDialogTitle">
                            <!-- 失败弹窗标题 文字 -->
                            <div class="failDialogTitle_txt" :dir="dirLang">
                                {{ failTitle }}
                            </div>
                        </div>
                        <!-- 失败弹窗内容 范围 -->
                        <div class="failDialogContent">
                            <!-- 失败弹窗内容 文字 -->
                            <div class="failDialogContent_txt" :dir="dirLang">
                                {{ failText }}
                            </div>
                        </div>
                        <div
                            style="left: 310px"
                            class="adoptLeftBtn failAcceptClick aaaa"
                            :class="{
                                toback: toBack,
                                skip1: highCheckShow && skipStyleShow,
                            }"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_10.png) no-repeat`}"
                            @click="failAcceptClick"
                        ></div>
                        <button
                            v-show="skipShow && !highCheckShow"
                            class="adoptRightBtn failCancelClick failSkip vvvv bg_skip"
                            @click="failAcceptSkip"
                        ></button>
                        <div
                            v-show="toBack"
                            class="adoptRightBtn failCancelClick"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_08.png) no-repeat`}"
                            @click="failCancelClick"
                        ></div>
                    </div>
                </div>
            </transition>            

            <!-- 失败弹窗，重置弹窗， 推出游戏弹窗   中文版本-->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200">
                <div class="codeIndexDialogMask" v-if="failDialogChina">
                    <div
                        class="adoptDialog failDialog failDialogChina"
                        :style="{ background: `url(${IMG_BASE_URL}errorChina_01.png) no-repeat`}" >
                        <!-- 失败弹窗标题 范围 -->
                        <div class="failDialogTitle failDialogTitleChina">
                            <!-- 失败弹窗标题 文字 -->
                            <div class="failDialogTitle_txt">
                                {{ failTitle }}
                            </div>
                        </div>
                        <!-- 失败弹窗内容 范围 -->
                        <div class="failDialogContent failDialogContentChina">
                            <!-- 失败弹窗内容 文字 -->
                            <div class="failDialogContent_txt">
                                {{ failText }}
                            </div>
                        </div>
                        <!--倒计时文字-->
                        <div class="failDialogContent failCountDownTxt " v-show="showElapse" 
                            :style = "{ background: `url(${IMG_BASE_URL}videoplay/icode-video-lock-time.png) no-repeat`}"
                            >
                            <div class="elapseTxtLeft">{{elapseTimeTxt}}</div>
                            <div class="elapseTxtRight">
                                <span>关卡过不去?<br /></span>
                                <span>{{elapseTimeTxt}}<br /></span>
                                <span>后视频观看解析</span>
                            </div>
                            <!-- <button @click="playVideoHandler" style="width:100px;height:40px;">ClickME</button> -->
                        </div>
                        <div class="failDialogContent failCountDownTxt clickViewVideo" v-show="showEndElapse" 
                            :style = "{ background: `url(${IMG_BASE_URL}videoplay/icode-video-play.png) no-repeat`}"
                            @click="playVideoHandler" >
                            <div class="elapseTxtLeft">&nbsp;</div>
                            <div class="elapseTxtRight">
                                <span>关卡过不去?<br /></span>
                                <span>点击视频观看解析</span>
                            </div>
                        </div>

                        <div class="failDialogContent failCountDownTxt " v-if="showUnVip" 
                            :style = "{ background: `url(${IMG_BASE_URL}videoplay/icode-video-lock.png)  no-repeat`}"
                            >
                            <div class="elapseTxtLeft">&nbsp;</div>
                            <div class="elapseTxtRight">
                                <span>成为正式宇航员<br /></span>
                                <span>查看解析视频</span>
                            </div>
                        </div>
                        <button
                            v-show="skipShow && !highCheckShow"
                            class="adoptRightBtn failCancelClick failSkip failSkipChina bg_skip"
                            @click="failAcceptSkip"
                        ></button>
                        <div
                            v-show="toBack"
                            class="adoptRightBtn failCancelClick failAcceptClickChina"
                            :style = "{ background: `url(${IMG_BASE_URL}errorChina_02.png) no-repeat`}"
                            @click="failCancelClick"
                        ></div>
                        <div
                            class="adoptLeftBtn failAcceptClick btoChina bg_errorChina_03"
                            :class="{
                                toback: toBack,
                                skip2: highCheckShow && skipStyleShow,
                            }"
                            @click="failAcceptClick"
                        ></div>
                    </div>
                </div>
            </transition>

            <!-- 登陆过期 sessionShow-->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200">
                <div class="codeIndexDialogMask" v-show="sessionShow">
                    <div
                        class="adoptDialog failDialog adoptDialog_en"
                        :style = "{ background: `url(${IMG_BASE_URL}popWin_03.png) no-repeat`}"
                    >
                        <!-- 失败弹窗标题 范围 -->
                        <div class="failDialogTitle">
                            <!-- 失败弹窗标题 文字 -->
                            <div
                                class="failDialogTitle_txt"
                                :dir="dirLang"
                                v-if="
                                    !monthlyGameShow && !timeoverShow && !ipShow
                                "
                            >
                                {{ $t("timeout01") }}
                            </div>
                            <div
                                class="failDialogTitle_txt"
                                :dir="dirLang"
                                v-if="
                                    monthlyGameShow && !timeoverShow && !ipShow
                                "
                            >
                                {{ $t("monthly_over_title") }}
                            </div>
                            <div
                                class="failDialogTitle_txt"
                                :dir="dirLang"
                                v-if="ipShow"
                            >
                                <!-- {{ $t("IPerror_title") }} -->
                            </div>
                            <div
                                class="failDialogTitle_txt"
                                :dir="dirLang"
                                v-if="timeoverShow"
                            >
                                {{ $t("timeup_title") }}
                            </div>
                        </div>
                        <!-- 失败弹窗内容 范围 -->
                        <div class="failDialogContent">
                            <!-- 失败弹窗内容 文字 -->
                            <div
                                class="failDialogContent_txt"
                                :dir="dirLang"
                                v-if="
                                    !monthlyGameShow && !ipShow && !timeoverShow
                                "
                            >
                                {{ $t("timeout02") }}
                            </div>
                            <div
                                class="failDialogContent_txt"
                                :dir="dirLang"
                                v-if="
                                    monthlyGameShow && !ipShow && !timeoverShow
                                "
                            >
                                {{ $t("monthly_over_content") }}
                            </div>
                            <div
                                class="failDialogTitle_txt"
                                :dir="dirLang"
                                v-if="ipShow"
                            >
                                {{ $t("IPerror_content") }}
                            </div>
                            <div
                                class="failDialogTitle_txt"
                                :dir="dirLang"
                                v-if="timeoverShow"
                            >
                                {{ $t("timeup_content") }}
                            </div>
                        </div>
                        <div
                            class="adoptLeftBtn failAcceptClick"
                            v-if="!monthlyGameShow && !ipShow"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_056.png) no-repeat`}"
                            @click="linkToPub()"
                        ></div>
                        <div
                            class="adoptLeftBtn failAcceptClick"
                            v-if="monthlyGameShow && !ipShow"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_056.png) no-repeat`}"
                            @click="linkToMonthly()"
                        ></div>
                        <div
                            class="adoptLeftBtn failAcceptClick"
                            v-if="ipShow"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_056.png) no-repeat`}"
                            @click="linkToFinals()"
                        ></div>
                        <div
                            class="adoptLeftBtn failAcceptClick"
                            v-if="timeoverShow"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_056.png) no-repeat`}"
                            @click="linkToFinals()"
                        ></div>
                    </div>
                </div>
            </transition>

            <!-- 退出游戏弹窗   中文版本-->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200">
                <div class="codeIndexDialogMask" v-if="exitGameMode">
                    <div
                        class="adoptDialog failDialog failDialogChina"
                        :style="{ background: `url(${IMG_BASE_URL}errorChina_01.png) no-repeat`}" >
                        <!-- 失败弹窗标题 范围 -->
                        <div class="failDialogTitle failDialogTitleChina">
                            <!-- 失败弹窗标题 文字 -->
                            <div class="failDialogTitle_txt">
                                {{ failTitle }}
                            </div>
                        </div>
                        <!-- 失败弹窗内容 范围 -->
                        <div class="failDialogContent failDialogContentChina">
                            <!-- 失败弹窗内容 文字 -->
                            <div class="failDialogContent_txt">
                                确认退出吗？您可以中途退出。当前关卡数据将会自动保存，下次进入时仍可继续当前的关卡。
                            </div>
                        </div>
                        
                        <button
                            v-show="skipShow && !highCheckShow"
                            class="adoptRightBtn failCancelClick failSkip failSkipChina bg_skip"
                            @click="failAcceptSkip"
                        ></button>
                        <div
                            v-show="toBack"
                            class="adoptRightBtn failCancelClick failAcceptClickChina"
                            :style = "{ background: `url(${IMG_BASE_URL}errorChina_02.png) no-repeat`}"
                            @click="failCancelClick"
                        ></div>
                        <div
                            class="adoptLeftBtn failAcceptClick btoChina bg_errorChina_03"
                            :class="{
                                toback: toBack,
                                skip2: highCheckShow && skipStyleShow,
                            }"
                            @click="failAcceptClick"
                        ></div>
                    </div>
                </div>
            </transition>



            <!-- skip到50关给的提示弹窗 -->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200"
            >
                <div class="codeIndexDialogMask" v-if="skipNextShow">
                    <div
                        class="adoptDialog failDialog failDialogChina skipeNext"
                        :style = "{
                            backgroundImage: `url(${IMG_BASE_URL}skip/${lang}errorChina_02.png) no-repeat`,
                            backgroundSize: 'contain'
                        }"
                    >
                        <div class="skipBtn" @click="skipNextBtn()"></div>
                    </div>
                </div>
            </transition>
            <!-- 切换语言的提示弹窗 -->
            <transition
                name="fade"
                @enter="ideResize"
                enter-active-class="animated bounceIn"
                :duration="200"
            >
                <div class="codeIndexDialogMask" v-if="checkLangDialogShow">
                    <div
                        class="adoptDialog failDialog adoptDialog_en"
                        :style = "{ background: `url(${IMG_BASE_URL}popWin_03.png) no-repeat`}"
                    >
                        <!-- 失败弹窗标题 范围 -->
                        <div class="failDialogTitle">
                            <!-- 失败弹窗标题 文字 -->
                            <div class="failDialogTitle_txt" :dir="dirLang">
                                {{ $t("is_switch_title") }}
                            </div>
                        </div>
                        <!-- 失败弹窗内容 范围 -->
                        <div class="failDialogContent">
                            <!-- 失败弹窗内容 文字 -->
                            <div
                                class="failDialogContent_txt"
                                :dir="dirLang"
                                v-html="$t('is_switch_language')"
                            ></div>
                        </div>
                        <div
                            style="left: 310px"
                            class="adoptLeftBtn failAcceptClick"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_10.png) no-repeat`}"
                            @click="langDiolog()"
                        ></div>
                        <div
                            class="adoptRightBtn failCancelClick"
                            :style = "{ background: `url(${IMG_BASE_URL}popWin_08.png) no-repeat`}"
                            @click="langDiologCancel()"
                        ></div>
                    </div>
                </div>
            </transition>
        </div>
        <!--  -->
        <transition
            name="fade"
            @enter="ideResize"
            enter-active-class="animated bounceIn"
            :duration="200"
        >
            <div class="dialogParent_explainDialog" v-show="explainDialog">
                <div
                    class="explainDialog"
                    ref="explainDialog"
                    :style = "{ background: `url(${IMG_BASE_URL}game_bg01.png) no-repeat`}"
                >
                    <div class="explainDialog_txt" v-show="explainDialog1">
                        <span :dir="dirLang">{{ $t("python") }}</span>
                    </div>
                    <div class="explainDialog_txt" v-show="explainDialog2">
                        <span :dir="dirLang">{{ $t("bgst") }}</span>
                    </div>
                    <div
                        v-if="explainDialog1"
                        class="explainDialog02"
                        :style="{
                            backgroundImage:
                                'url(' +
                                createURL +
                                '/static/images/knowledge/' +
                                lang +
                                '/' +
                                knowledgeArr.image +
                                ')',
                            backgroundSize: 'contain',
                        }"
                    ></div>
                    <div v-if="explainDialog2" class="explainDialog02" :style="{backgroundImage:'url(' +createURL +'/static/images/story/' +lang +'/' +knowledgeArr.image +')',backgroundSize: 'contain',}" ></div>
                    <!--<div class="explainDialog02" :style="{background: 'url(https://istatic.codingolympics.cn/assets/create/static/images/knowledge/' + lang + '/' + knowledgeArr.image +') no-repeat'}"></div>-->
                    <div class="explainDialog04" 
                        :style = "{ background: `url(${IMG_BASE_URL}border03.png) no-repeat`}"
                        ></div>
                    <div class="explainDialog03" @click="explainDialogHide()" 
                        :style = "{ background: `url(${IMG_BASE_URL}game_demo03.png) no-repeat`}"
                        ></div>
                </div>
            </div>
        </transition>

        <!--体验关卡通关并可以领取奖励-->
        <transition
            name="fade"
            @enter="ideResize"
            enter-active-class="animated bounceIn"
            :duration="200">
            <div class="videoMaskContainer" v-show="tourCompelete">
                <div class="dialogParent_explainDialog" >
                    <div
                        class="explainDialog"
                        ref="explainDialog"
                        :style="{ 
                            background: `url(${IMG_BASE_URL}hour/icode_onhour_all_pass.png) no-repeat`,
                            backgroundSize: 'contain'
                        }" >
                    
                        <img :src="`${IMG_BASE_URL}hour/icode_onhour_get_price.png`" @click="quitCurrentToure(1)" class="hourGetPrize" />
                        <img :src="`${IMG_BASE_URL}hour/icode_onhour_continue_btn.png`" @click="continueCurrentTourHandler()" class="hourGetPrizeContinue" />
                    </div>
                </div>
            </div>
        </transition>

        <!--退出当前挑战-->
        <transition
            name="fade"
            @enter="ideResize"
            enter-active-class="animated bounceIn"
            :duration="200">
            <div class="videoMaskContainer" v-show="tourNotCompelete">
                <div class="dialogParent_explainDialog" >
                    <div
                        class="explainDialog_onhour"
                        ref="explainDialog"
                        :style="{ 
                            background: `url(${IMG_BASE_URL}hour/icode_onhour_exit_confirm.png) no-repeat`,
                            backgroundSize: 'contain'}" >
                    
                        <img :src="`${IMG_BASE_URL}hour/icode_onhour_continue_btn.png`" @click="continueCurrentTour(0)" class="hourContinueGameBtn" />
                        <img :src="`${IMG_BASE_URL}hour/icode_onhour_exit.png`" @click="quitCurrentToure(0)" class="hourExitGameBtn" />
                    </div>
                </div>
            </div>
        </transition>

        <!--通关但未能拿到20分-->
        <transition
            name="fade"
            @enter="ideResize"
            enter-active-class="animated bounceIn"
            :duration="200">
            <div class="videoMaskContainer" v-show="tourCompeleteNotGet">
                <div class="dialogParent_explainDialog" >
                    <div
                        class="explainDialogNotComplete"
                        ref="explainDialog"
                        :style="{ 
                            background: `url(${IMG_BASE_URL}hour/icode_onhour_not_complete.png) no-repeat`,
                            backgroundSize: 'contain'
                        }" >
                    
                        <img :src="`${IMG_BASE_URL}hour/icode_onhour_exit.png`" @click="quitCurrentToure(0)" class="hourExitGameBtn20" />
                        <img :src="`${IMG_BASE_URL}hour/icode_onhour_continue_btn.png`" @click="continueCurrentTour(1)" class="hourContinueGameBtn20" />
                    </div>
                </div>
            </div>
        </transition>

        <!--没有通关-->
        <transition
            name="fade"
            @enter="ideResize"
            enter-active-class="animated bounceIn"
            :duration="200">
            <div class="videoMaskContainer" v-show="tourGameNotPass">
                <div class="dialogParent_explainDialog" >
                    <div
                        class="explainDialogNotComplete"
                        ref="explainDialog"
                        :style="{ 
                            background: `url(${IMG_BASE_URL}hour/icode_onhour_not_all_pass.png) no-repeat`,
                            backgroundSize: 'contain'
                            }" >
                    
                        <img :src= "`${IMG_BASE_URL}hour/icode_onhour_not_all_pass_btn.png`"
                            @click="continueCurrentTour(1)" 
                            class="hourGameNotPassBtn"
                            />
                    </div>
                </div>
            </div>
        </transition>

        <!-- 游戏内容区域 -->
        <div id="gameContent">
            <!-- 头部 -->
            <headBox ref="headBox"></headBox>
            <!-- 游戏和编辑器部分 -->
            <idebox ref="idebox"></idebox>
        </div>
        <!-- 关卡图 -->
        <transition
            name="fade"
            @enter="ideResize"
            enter-active-class="animated bounceIn"
            :duration="200"
        >
            <checkpoint
                :v-loading="loading"
                ref="chkpoint"
                enter-active-class="animated bounceIn"
                v-if="checkpointShow"
            ></checkpoint>
        </transition>
        
    
        <div class="videoMaskContainer" v-if="dialogVisible">
            <div class="videoPlayer">
                <video-player    class="vjs-custom-skin"
                    ref="videoPlayer"
                    :options="playerOptions"
                    :playsinline="true"
                    @play="onPlayerPlay($event)"
                    @pause="onPlayerPause($event)"
                    @ended="onPlayerEnded($event)"
                    @loadeddata="onPlayerLoadeddata($event)"
                    @waiting="onPlayerWaiting($event)"
                    @playing="onPlayerPlaying($event)"
                    @timeupdate="onPlayerTimeupdate($event)"
                    @canplay="onPlayerCanplay($event)"
                    @canplaythrough="onPlayerCanplaythrough($event)"
                    @ready="playerReadied"
                    @statechanged="playerStateChanged($event)">
                </video-player>
                <div class="closeVideoButton" @click="handleClose()" 
                    :style="{background: `url(${IMG_BASE_URL}videoplay/ICODE_VIDEO_CLOSE.png) no-repeat`, backgroundSize: 'contain'}"
                    ></div>
            </div>
        </div>
        <vue-draggable-resizable  :lock-aspect-ratio="true" :w="330" :h="212" :resizable="false"
            id="cameraVideoContainer" v-if="cameraVisible" :z="zindex" :style="{
                    background: `url(${IMG_BASE_URL}videobg.png) no-repeat`,
                    backgroundSize: 'cover',
                }">
            <video  id="cameraVideo"></video>
            <canvas id="hideCanvas" style="visibility:hidden"></canvas>
        </vue-draggable-resizable>
         
    </div>
</template>

<script>
import OnlineClass from "./online-class";
export default OnlineClass;
</script>

<style src="../css/online-class.css"></style>



// WEBPACK FOOTER //
// src/components/onlineClass.vue